import React, { useEffect, useState } from 'react';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { LabelValueCard, PageLoader } from '../../../../shared_elements';
import { Grid, Paper, Tooltip } from '@material-ui/core';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils_v2/globalApiServices';
import { checkApiStatus, checkPermission, toastFlashMessage } from '../../../../utils_v2';
import EditSubleaseCard from './EditSubleaseCard';
import { EditSidebar, InvoiceConfigCol } from '../../../../applications/contracts/Elements';
import { Row } from 'reactstrap';
import { avationPlcInstance, leshaBankInstance, mtInstance } from '../../../../shared_elements/components';
export default function SubleaseCard({props}) {
  const [editModal, setEditModal] = useState({ modal: false });
  const [subleasecard, SetSubleasecard] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState({});
  
  useEffect(() => {
    getSubleaseCard();
  }, [])
  const toggleEditSideBar = (data) => {
    setEditModal({ modal: true, data: subleasecard })
  }
  const getSubleaseCard = () => {
    setLoading(true);
    globalGetService(`/contracts/contract-details/${props.params.contract_slug}/`)
      .then((response) => {
        setLoading(false);
        if (checkApiStatus(response)) {
          SetSubleasecard(response?.data.data);
        }else{
            toastFlashMessage(response?.data.message, 'error');
        }
      })
  }
  const updateWetLeaseCard = (data, type, assetViewId) => {
    setLoading(true);
    globalPutService(`contracts/contract-details/${props.params.contract_slug}/`, data)
      .then(response => {
        if (checkApiStatus(response)) {
          setEditModal({ modal: false });
          getSubleaseCard();
          setLoading(false);
          toastFlashMessage('SubLease Details Updated Successfully', 'success');
        } else {
          setLoading(false);
          toastFlashMessage('Error Occured while updating SubLease Details', 'error');
        }
      }
      )
  }

  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };

  return (
    <>
    <div className="data-invoice-block" style={{marginTop:'16px'}}>
      {checkPermission('contracts','sublease', 'U') ?
      <h5 className="para">
        <Tooltip title="Edit Sublease Details" placement="top">
          <img style={{ float: 'right', cursor: 'pointer' }} onClick={toggleEditSideBar} width="16" className="editIcon" src={editIconWhite} alt="img" />
        </Tooltip>
      </h5>:null}
      <Row>
          <InvoiceConfigCol
            size="4"
            title="Right to Sub Lease without prior Approval"
            value={subleasecard?.titan_extra_fields?.right_sublease_without_approval||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Sub Lease Fee"
            value={subleasecard?.titan_extra_fields?.sublease_fee||'--'}
          /> 
          {(mtInstance || avationPlcInstance || leshaBankInstance) ?
          <InvoiceConfigCol
            size="6"
            title="Sub Lease Comment"
            value={subleasecard?.titan_extra_fields?.sublease_comment && subleasecard?.titan_extra_fields?.sublease_comment?.length > 200 ? (
              <div>
                {showMore[subleasecard?.id] && showMore[subleasecard?.id] ? (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: subleasecard?.titan_extra_fields?.sublease_comment.replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(subleasecard.id); }} >
                      less
                    </a>
                  </span>
                ) : (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: subleasecard?.titan_extra_fields?.sublease_comment.substring(0, 190).replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(subleasecard.id); }} >
                      ..more
                    </a>
                  </span>
                )}
              </div>
            ) : (
              <div>
                   {subleasecard?.titan_extra_fields?.sublease_comment ? <span dangerouslySetInnerHTML={{ __html: subleasecard?.titan_extra_fields?.sublease_comment.replace(/\n/g, '<br />') }} />:'--'}
              </div>
            )} 
          /> :null }
      </Row>
    </div>
      {editModal.modal ?
        <EditSidebar
          title={`Edit SubLease Details`}
          editSideBar={editModal?.modal}
          toggleEditSideBar={() => setEditModal({ modal: false })}
        >
          <EditSubleaseCard 
              type="edit"
              subleasecard={subleasecard}
              toggleEditSideBar={() => setEditModal({ modal: false })}
              updateWetLeaseCard={(data) => updateWetLeaseCard(data,)}
          />
        </EditSidebar> : null}
        {isLoading?<PageLoader/>:null}
    </>
  )
}
